import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import AppRoutes from '../../constants/AppRoutes';
import Messages from '../../constants/Messages';
import arrowLeft from './images/arrow-left.svg';
import CartService from '../../services/cart-service';

const Header = (props) => {
    const {
        title,
        isPrevActive = false,
        prevNavigationText = null,
        prevPath = AppRoutes.HOME,
        isClearCart = false
    } = props;

    return (
        <header className='p-2 pt-4 pb-4 top-0 flex bg-white sticky z-10'>
            {
                isPrevActive ? (
                    <div className='flex items-center font-medium'>
                        <Link to={prevPath}>
                            <img src = {arrowLeft} className = 'w-4 mr-4' alt = "Navigate" onClick={() => isClearCart ? CartService.clearCart() : null}/>
                        </Link>
                        {prevNavigationText}
                    </div>
                ) : (
                    <div className='w-full items-center justify-center text-center font-bold'>
                        {title || Messages.APP_TITLE}
                    </div>
                )
            }
        </header>
    )
}

Header.propTypes = {
    title: PropTypes.string,
    prevNavigationText: PropTypes.string,
    prevPath: PropTypes.string,
    isPrevActive : PropTypes.bool,
    isClearCart : PropTypes.bool
};

export default Header;